import { render, staticRenderFns } from "./EventFile.vue?vue&type=template&id=256a8d12"
import script from "./EventFile.vue?vue&type=script&lang=js"
export * from "./EventFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports